import * as Actions from '@/store/actions/types/analytics';
import { createAction } from '@/store/actions/utils';
export const loadBeaconHealthcheck = () => createAction(Actions.LOAD_BEACON_HEALTHCHECK);
export const refreshBeaconHealthcheck = (healthchecks) => createAction(Actions.REFRESH_BEACON_HEALTHCHECK, healthchecks);
export const runQuickcheck = (id) => createAction(Actions.RUN_BEACON_QUICKCHECK, id);
